import React from 'react'
import { ServiceInfo } from '../InfoPage'
import { Card, CardHeader, Body1Strong, Body2, Link, Subtitle1 } from '@fluentui/react-components';
import { Info16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

const ServiceInfoCard : React.FC<{
  service: ServiceInfo;
  styles: any;
}> = ({service, styles}) => {
  const { t } = useTranslation();
  return (
    <Card key={service.id} className={styles.serviceCard}>
        <CardHeader
            header={
                <div className={styles.serviceHeader}>
                    <div className={styles.serviceIcon}>{service.icon}</div>
                    <Subtitle1>{service.name}</Subtitle1>
                </div>
            }
            description={<Body2>{service.description}</Body2>}
        />
        
        <div className={styles.serviceContent}>
            <Body1Strong className={styles.stepsTitle}>
                {t('info.services.steps', 'Setup Steps:')}
            </Body1Strong>
            <ol className={styles.stepsList}>
            {service.steps.map((step) => (
                <li key={step}>
                    <Body2>{step}</Body2>
                </li>
            ))}
            </ol>

            <div className={styles.serviceInfo}>
                <div className={styles.infoRow}>
                    <Info16Regular className={styles.infoIcon} />
                    <Body2>
                        <strong>{t('info.services.baseUrl', 'Base URL:')}</strong> {service.baseUrl}
                    </Body2>
                </div>
            
                {service.note && (
                    <div className={styles.infoRow}>
                        <Info16Regular className={styles.infoIcon} />
                        <Body2>
                            <strong>{t('info.services.note', 'Note:')}</strong> {service.note}
                        </Body2>
                    </div>
                )}

                {service.url && (
                    <Link 
                        href={service.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className={styles.serviceLink}
                    >
                        {t('info.services.getKey', 'Get API Key')} →
                    </Link>
                )}

                {service.pricingUrl && (
                    <Link 
                        href={service.pricingUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className={styles.serviceLink}
                    >
                        {t('info.services.viewPricing', 'View Pricing')}
                    </Link>
                )}
            </div>
        </div>
    </Card>
  )
}

export default ServiceInfoCard